export default __webpack_public_path__ + "static/media/illo.57e4c1f9.jpg";